import React from "react";
import BlockToggle from "views/admin/moqawelon/components/BlockToggle";
import DeleteUser from "views/admin/users/components/DeleteUser";
import EditAdmin from "views/admin/admins/components/EditAdmin";
import api from "utils/apiService";
import { toast } from "react-toastify";
import { getDecodedUser } from "utils/utils";

const currentUser = getDecodedUser();

const AdminsColumn = (refetch) => [
  {
    Header: "تحديد",
    id: "checkbox",
  },
  {
    Header: "الاسم",
    accessor: "name",
  },
  {
    Header: "رقم الهاتف",
    accessor: "phoneNumber",
    Cell: ({ row }) => (
      <a
        className="text-blue-500 hover:underline"
        href={`tel:${row.original.phoneNumber}`}
      >
        {row.original.phoneNumber}
      </a>
    ),
  },
  {
    Header: "الحالة",
    accessor: "active",
    Cell: ({ row }) => (
      <span
        className={`rounded-full px-2 py-1 text-xs ${
          row.values.active
            ? "bg-green-500 text-white"
            : "bg-red-500 text-white"
        }`}
      >
        {row.values.active ? "مفعل" : "غير مفعل"}
      </span>
    ),
  },
  {
    Header: "إجراء",
    accessor: "id",
    Cell: ({ row }) => {
      const isSelf =
        currentUser?.id === row.original.id ||
        currentUser?._id === row.original.id;
      return (
        <div className="flex flex-col items-start gap-2">
          <EditAdmin admin={row.original} refetch={refetch} />
          {!isSelf && (
            <>
              {row.original.active ? (
                <BlockToggle
                  id={row.original.id}
                  refetch={refetch}
                  name={row.original.name}
                />
              ) : (
                <button
                  className="rounded-full bg-green-500 px-6 py-1 text-white transition-all hover:bg-green-600 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
                  onClick={() =>
                    handleToggle(row.original.id, "active", refetch)
                  }
                >
                  تفعيل
                </button>
              )}
              <DeleteUser id={row.original.id} refetch={refetch} />
              {currentUser?.superAdmin && (
                <button
                  className="rounded-full bg-purple-500 px-6 py-1 text-white transition-all hover:bg-purple-600"
                  onClick={() =>
                    handleToggleSuperAdmin(row.original.id, refetch)
                  }
                >
                  {row.original.superAdmin
                    ? "إلغاء صلاحية المدير العام"
                    : "تفعيل صلاحية المدير العام"}
                </button>
              )}
            </>
          )}
        </div>
      );
    },
  },
];

const handleToggle = async (id, status, refetch) => {
  const { handleToggleContractors } = await import("actions/actions");
  const res = await handleToggleContractors(id, status);
  const { toast } = await import("react-toastify");
  if (res.error) {
    toast.error(res.error);
  } else {
    toast.success(res.success);
    refetch();
  }
};

const handleToggleSuperAdmin = async (id, refetch) => {
  const res = await api.patch(`/users/${id}/toggleSuperAdmin`);
  if (res.error) {
    toast.error(res.error);
  } else {
    toast.success(res.success || "تم التحديث بنجاح");
    refetch();
  }
};

export { AdminsColumn };
